import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class AdmissionService {

  constructor(private _http: HttpClient) {
  }

  getNumberOfSubjectForAdmissionList(page) {
    return this._http.post<any>('api/a/dict/admission/number/of/subject/setting/all/list', page);
  }

  saveNumberOfSubjectForAdmission(dto) {
    return this._http.post<any>('api/a/dict/admission/number/of/subject/setting/save', dto);
  }

  deleteNumberOfSubjectForAdmission(id) {
    return this._http.delete<any>('api/a/dict/admission/number/of/subject/setting/' + id);
  }

  getNumberOfSubjectForAdmissionListByYear(year) {
    return this._http.get<any>(`api/a/dict/admission/number/of/subject/setting/all/list/${year}`);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/services/admission.service.ts